import { render, staticRenderFns } from "./BrandCensus.vue?vue&type=template&id=7688e28f&scoped=true"
import script from "./BrandCensus.vue?vue&type=script&lang=js"
export * from "./BrandCensus.vue?vue&type=script&lang=js"
import style0 from "./BrandCensus.vue?vue&type=style&index=0&id=7688e28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688e28f",
  null
  
)

export default component.exports